<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <v-row align="center">
        <v-col cols="12" class="text-right" >
          <v-dialog v-model="dialog" max-width="445">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                      v-bind="attrs"
                      v-on="on"
              >
                Добавить
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ cashback.id ? 'Редактировать кешбек' : 'Создать кешбек'}}</span>
              </v-card-title>
              <v-card-text>
                  <v-text-field label="Сумма" suffix="UAH" outlined v-model="cashback.sum"></v-text-field>
                  <v-text-field label="Процент" suffix="%" outlined v-model="cashback.percent"></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-btn v-if="cashback.id" @click="updateCashback(); dialog = false" :loading="loadingModal">Сохранить</v-btn>
                <v-btn v-else @click="createCashback(); dialog = false" :loading="loadingModal">Добавить</v-btn>
                <v-btn outlined @click="dialog = false">Отменить</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <v-data-table
              no-data-text="Нет тегов"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :items="cashbacks"
              :options.sync="options"
              :footer-props="footerProps"
              :loading="loading"
              loading-text="Загрузка тегов... Подождите пожалуйста"
      >
        <template v-slot:item.sum="{ item }">
          <v-text-field hide-details outlined v-model="item.sum" dense suffix="UAH" @change="updateCashback(item  )"></v-text-field>
        </template>
        <template v-slot:item.percent="{ item }">
          <v-text-field hide-details outlined v-model="item.percent" dense suffix="%" @change="updateCashback(item  )"></v-text-field>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-right">
            <v-menu offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="removeCashback">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-overlay
            :z-index="4"
            :value="overlay"
    >
    </v-overlay>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import SaleService from "../../api/SaleService";

    export default {
        name: 'Cashback',
        components: {},
        data: () => ({
            overlay: false,
            loadingModal: false,
            loading: true,
            tab: null,
            dialog: false,
            cashbacks: [],
            options: {},
            cashback: {
                id: null,
                sum: '',
                parcent: '',
            },
            footerProps: {
                itemsPerPageText: 'Элементов на страницу',
                pageText: '{0}-{1} из {2}',
                itemsPerPageAllText: 'Все',
                itemsPerPageOptions: [-1]
            },
            totalProducts: 0,
            headers: [
                {
                    text: 'Сумма',
                    value: 'sum',
                    width: '1%'
                },
                {
                    text: 'Кешбек',
                    value: 'percent',
                    width: '1%'
                },
                {text: '', value: 'actions', sortable: false, width: "5%"},
            ],
        }),
        mounted() {
        },
        watch: {
            options: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
        },
        methods: {
            removeCashback(){

            },
            createCashback(){
                this.loadingModal = true;
                SaleService.createCashback(this.cashback).then(response => {
                    this.getDataFromApi();
                    this.loadingModal = false;
                })
            },
            updateCashback(item){
                SaleService.updateCashback(item.id, {sum: item.sum, percent: item.percent}).then(response => {
                    this.getDataFromApi();
                })
            },
            getDataFromApi() {
                this.loading = true

                SaleService.listCashback({})
                    .then(response => {
                        this.cashbacks = response.data
                        this.loading = false
                    })
            },
        }
    }
</script>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
